export default __webpack_public_path__ + "static/media/Car.a40270f3.svg";